<template>
  <div class="menu-page">
    <div class="menu-page-left">
      <a-tree
        ref="myTree"
        v-if="treeData != null"
        :treeData="treeData"
        style="overflow: auto;height:calc(100vh - 225px)"
        @select="onSelect"
        :expandedKeys.sync="expandArray"
        :selectedKeys.sync="selectedKeys"
      >
      </a-tree>
    </div>
    <div class="menu-page-right">
      <div class="menu-page-view">
        <component :is="componentName" :record="record" :code="activeKey" />
      </div>
    </div>
  </div>
</template>

<script>
import pages from "./basePages";
const treeData = [
  {
    title: "供应商",
    key: "Supplier",
    children: [
      {
        title: "供应商类别",
        key: "SupplierType"
      },
      {
        title: "供应商",
        key: "SupplierList"
      }
    ]
  },
  {
    title: "物品",
    key: "Goods",
    children: [
      {
        title: "物品类别",
        key: "GoodsType"
      },
      {
        title: "物品名称",
        key: "GoodsList"
      }
    ]
  },
  {
    title: "仓库管理",
    key: "StockManage"
  }
];
export default {
  name: "BaseSetting",
  components: {
    ...pages
    // SelectTree
  },
  data() {
    return {
      component: "SupplierType",
      expandArray: ["Supplier", "Goods"],
      selectedKeys: ["SupplierType"],
      record: "",
      treeData,
      activeKey: "",
      currentKey: ""
    };
  },
  created() {},
  computed: {
    //组件判断函数
    componentName() {
      //如果能在导入文件index.js中找到对应名字，则启动对应页面
      if (pages[this.activeKey]) {
        return pages[this.activeKey];
      }
      //如果在导入文件index.js中找不到对应名字，则启动Base页面
      return "SupplierType";
    }
  },
  methods: {
    onSelect(selectedKeys) {
      if (this.selectedKeys.length) {
        this.currentKey = selectedKeys;
        this.activeKey = selectedKeys;
      } else {
        this.activeKey = this.currentKey;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.menu-page {
  width: 100%;
  display: flex;
  // height: calc(100vh - 180px);
  overflow: auto;

  &.mobile {
    display: block;

    .menu-page-left {
      border-right: unset;
      border-bottom: 1px solid #e8e8e8;
      width: 100%;
      height: 50px;
      overflow-x: auto;
      overflow-y: scroll;
    }
    .menu-page-right {
      padding: 20px 40px;
    }
  }

  .menu-page-left {
    border-right: 1px solid #e8e8e8;
    flex: 0 0 160px;
    max-width: 160px;
    min-width: 160px;
    width: 160px;
    height: 100%;
  }

  .menu-page-right {
    flex: 1 1;
    padding: 8px 40px;
    width: 100%;
    overflow: hidden;
    .menu-page-title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 12px;
    }
    .menu-page-view {
      padding-top: 12px;
    }
  }
}
</style>
